/* @flow */

import { rem } from 'polished';

import { fadeDuration } from '@e180/ui/lib/token/animation';
import { antialiasing } from 'src/shared/app/base/style/token/helper';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',

    width: '100%',
    height: '100%',
    padding: '8px 8px 24px',

    transition: `opacity ${fadeDuration}`,
  },
  'root-isHidden': {
    opacity: 0,
  },
  top: {
    width: '100%',
  },
  heading: {
    maxWidth: 240,
    margin: '8px auto 32px',
  },
  meeting: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    maxWidth: 300,
    marginBottom: 48,
    padding: 8,
  },
  instructions: {
    extend: antialiasing,

    margin: [0, 0, rem(36, baseFontSize)],

    fontSize: rem(18, baseFontSize),
    lineHeight: 26 / 18,
    textAlign: 'center',
  },
  join: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    minWidth: 176,
    height: rem(52, baseFontSize),
  },
  joinIcon: {
    marginRight: rem(12, baseFontSize),

    fill: 'currentColor',
  },
};
